import { useState, useEffect } from 'react';
import { getThemePref, setThemePref, type ThemePref } from '../lib/theme';

const CYCLE: ThemePref[] = ['system', 'light', 'dark'];

export function useTheme() {
  const [pref, setPref] = useState<ThemePref>(getThemePref);
  const set = (p: ThemePref) => { setThemePref(p); setPref(p); };
  const cycle = () => set(CYCLE[(CYCLE.indexOf(pref) + 1) % CYCLE.length]!);
  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === 'naia.theme') setPref(getThemePref());
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);
  return { pref, set, cycle };
}
